import { Modal, Popconfirm } from "antd";

const STEP_KEY = {
  Agenda: "AG",
  CoachMeetings: "CM",
  MeetingNotes: "ME",
  CoachFeedback: "CF",
  MyNotebook: "MN",
  Meditations: "MD",
  MindsetGoals: "MG",
  BuildingConfidence: "BG",
  EnvisioningYourself: "EY",
  InfluenceZones: "IZ",
  PastRolesReflection: "RL",
  NetworkingPreparation: "NN",
  ProgressTracker: "PT",
  SuggestedSchedule: "SS",
  MyTasks: "MT",
  AccountabilityGroupCoworking: "GC",
  MissionStatement: "MS",
  LifeWheel: "LS",
  AnnualGoals: "AL",
  FinancialManagement: "FM",
  RelationshipManagement: "RM",
  TravelAndAdventure: "TN",
  GivingAndContribution: "GT",
  Spiritual: "SR",
  HealthAndWellness: "HW",
  LocationToLive: "LT",
  Peers: "PE",
  Therapist: "TH",
  Stakeholders: "KH",
  Manager: "MA",
  Mentors: "MO",
  MyBoardOfDirectors: "MB",
  GroupCoworking: "GW",
  GroupCoaching: "GH",
  GroupMeditation: "GM",
  DiscussionBoard: "DB",
  AccountabilityTriads: "AD",
  PeerCoaching: "PC",
  AnnualGoalBuddy: "AB",
  ReadingBuddy: "RB",
  Settings: "SE",
  Security: "SC",
  MyPlan: "MP",
  Billing: "BL",
  Integrations: "IN",
  ShareFeedback: "SF",
  // PrivacyPolicy: "PP",
  // Logout: "LG",
  Onboarding: "ON",
  Assessment: "AS",
  TargetRoles: "TR",
  TargetIndustries: "TI",
  ResearchRoles: "RR",
  ResearchIndustries: "RI",
  ResearchAddNew: "RN",
  Contacts: "CO",
  EmailDrafts: "ED",
  Tracker: "NT",
  CallPrep: "CP",
  CallNotes: "CN",
  NetworkingReflections: "NF",
  NetworkingAddNew: "NA",
  LearningOpportunities: "LO",
  ExperiencesAddNew: "EN",
  ProfessionalSummary: "PS",
  Resume: "RE",
  CoverLetter: "CL",
  Linkedin: "LK",
  ApplicationTracker: "AT",
  InterviewResearch: "IR",
  InterviewPractice: "BP",
  Reflections: "JR",
  JobSearchAddNew: "JS",
  TargetRolesAndIndustries: "AE",
  CompareRoles: "CR",
  PieChartExercise: "PCE",
  ResumeVisionExercise: "RV",
  KeyDefinitions: "KD",
  IdentifyGaps: "ID",
  CareerTrajectory: "CT",
  StrengthsOverview: "SO",
  SkillGapAnalysis: "SG",
  JobPostingExercise: "JP",
  // UpskillingTracker: "UT",
  CompareOptions: "OT",
  MyCredentials: "MC",
  KeyLinks: "KL",
  SoftSkillDevelopment: "SD",
  BoundarySetting: "BS",
  Communication: "UP",
  TimeManagement: "TM",
  ProjectManagement: "PM",
  ImprovingFocus: "IF",
  InfluenceAndVisibility: "IV",
  VideoPitch: "VP",
  PortfolioOrWebsite: "PW",
  ThoughtLeadership: "TL",
  ATSKeywords: "AK",
  MindsetPreparation: "NN",
  PlacesToNetwork: "PN",
  PastEvents: "EV",
  UpcomingEvents: "UE",
  FindEvents: "FE",
  Onboarding_30_60_90: "OD",
  OnboardingChecklist: "OC",
  Promotions: "PR",
  InternalMobility: "IM",
  PerformanceReviews: "MV",
  JobExpectations: "JE",
  CareerAdvencementsAnnualGoals: "CG",
  StakeholderUpdates: "SU",
  TrackAchievements: "TA",
  Roadmap: "EM",
  CustomerPersonas: "CS",
  MarketResearch: "MR",
  DefineOfferings: "DO",
  Financials: "FN",
  Marketing: "MK",
  Sales: "SL",
  ProductDevelopment: "PD",
  TeamManagement: "ET",
  Legal: "EL",
  Operations: "OP",
  JobSearchingProgressTracker: "JT",
  StrategyAndDirection: "SN",
  Calendar: "CA",
  JobSearchingSuggestedSchedule: "JA",
  TargetJobPostings: "TJ",
  TargetCompanies: "TC",
  StaffingAgencies: "SA",
  VisaResources: "VR",
  SetPriorities: "SP",
  QuestionsToAsk: "QT",
  MockInterview: "MW",
  CaseInterview: "CI",
  TechnicalInterview: "TE",
  InterviewFollowUps: "IW",
  StandingOut: "ST",
  OfferAnalysis: "OA",
  SalaryResearch: "SH",
  JobSearchingKeyLinks: "SK",
  HelpfulTools: "HT",
  EducationPlanning: "EP",
  MyCommitment: "MCM",
  MySchedule: "MSC",
  KeyLinksJob: "KLJ",
  WOKENVideosMeditations: "WVM",
  OtherVideos: "OVD",
  WOKENBook: "WB",
  OtherBooks: "OTB",
  WOKENBlogs: "WKB",
  OtherBlogs: "OBL",
  WOKENWorkshops: "WW",
  Podcasts: "PDC",
  Templates: "TMP",
  FAQ: "FAQ",
  Whiteboard: "WHB",
  AccountabilityMySchedule: "AMS",
};

const order = [
  STEP_KEY.AccountabilityMySchedule,
  STEP_KEY.MyCommitment,
  STEP_KEY.WOKENWorkshops,
  STEP_KEY.MySchedule,
  STEP_KEY.Whiteboard,
  STEP_KEY.KeyLinksJob,
  STEP_KEY.WOKENVideosMeditations,
  STEP_KEY.OtherVideos,
  STEP_KEY.WOKENBook,
  STEP_KEY.OtherBooks,
  STEP_KEY.WOKENBlogs,
  STEP_KEY.OtherBlogs,
  STEP_KEY.Podcasts,
  STEP_KEY.Templates,
  STEP_KEY.FAQ,
  STEP_KEY.EducationPlanning,
  STEP_KEY.OfferAnalysis,
  STEP_KEY.SalaryResearch,
  STEP_KEY.JobSearchingKeyLinks,
  STEP_KEY.HelpfulTools,
  STEP_KEY.QuestionsToAsk,
  STEP_KEY.MockInterview,
  STEP_KEY.CaseInterview,
  STEP_KEY.TechnicalInterview,
  STEP_KEY.InterviewFollowUps,
  STEP_KEY.StandingOut,
  STEP_KEY.TargetJobPostings,
  STEP_KEY.TargetCompanies,
  STEP_KEY.StaffingAgencies,
  STEP_KEY.VisaResources,
  STEP_KEY.SetPriorities,
  STEP_KEY.JobSearchingProgressTracker,
  STEP_KEY.StrategyAndDirection,
  STEP_KEY.Calendar,
  STEP_KEY.JobSearchingSuggestedSchedule,
  STEP_KEY.Roadmap,
  STEP_KEY.CustomerPersonas,
  STEP_KEY.MarketResearch,
  STEP_KEY.DefineOfferings,
  STEP_KEY.Financials,
  STEP_KEY.Marketing,
  STEP_KEY.Sales,
  STEP_KEY.ProductDevelopment,
  STEP_KEY.TeamManagement,
  STEP_KEY.Legal,
  STEP_KEY.Operations,
  STEP_KEY.Onboarding_30_60_90,
  STEP_KEY.OnboardingChecklist,
  STEP_KEY.Promotions,
  STEP_KEY.InternalMobility,
  STEP_KEY.PerformanceReviews,
  STEP_KEY.JobExpectations,
  STEP_KEY.CareerAdvencementsAnnualGoals,
  STEP_KEY.StakeholderUpdates,
  STEP_KEY.TrackAchievements,
  STEP_KEY.PastEvents,
  STEP_KEY.UpcomingEvents,
  STEP_KEY.FindEvents,
  STEP_KEY.MindsetPreparation,
  STEP_KEY.PlacesToNetwork,
  STEP_KEY.VideoPitch,
  STEP_KEY.PortfolioOrWebsite,
  STEP_KEY.ThoughtLeadership,
  STEP_KEY.ATSKeywords,
  STEP_KEY.BoundarySetting,
  STEP_KEY.Communication,
  STEP_KEY.TimeManagement,
  STEP_KEY.ProjectManagement,
  STEP_KEY.ImprovingFocus,
  STEP_KEY.InfluenceAndVisibility,
  STEP_KEY.StrengthsOverview,
  STEP_KEY.SkillGapAnalysis,
  STEP_KEY.JobPostingExercise,
  // STEP_KEY.UpskillingTracker,
  STEP_KEY.CompareOptions,
  STEP_KEY.MyCredentials,
  STEP_KEY.KeyLinks,
  STEP_KEY.SoftSkillDevelopment,
  STEP_KEY.KeyDefinitions,
  STEP_KEY.IdentifyGaps,
  STEP_KEY.CareerTrajectory,
  STEP_KEY.TargetRolesAndIndustries,
  STEP_KEY.ResumeVisionExercise,
  STEP_KEY.Agenda,
  STEP_KEY.CoachMeetings,
  STEP_KEY.MeetingNotes,
  STEP_KEY.CoachFeedback,
  STEP_KEY.MyNotebook,
  STEP_KEY.Meditations,
  STEP_KEY.MindsetGoals,
  STEP_KEY.BuildingConfidence,
  STEP_KEY.EnvisioningYourself,
  STEP_KEY.InfluenceZones,
  STEP_KEY.PastRolesReflection,
  STEP_KEY.NetworkingPreparation,
  STEP_KEY.ProgressTracker,
  STEP_KEY.SuggestedSchedule,
  STEP_KEY.MyTasks,
  STEP_KEY.MissionStatement,
  STEP_KEY.LifeWheel,
  STEP_KEY.AnnualGoals,
  STEP_KEY.FinancialManagement,
  STEP_KEY.RelationshipManagement,
  STEP_KEY.TravelAndAdventure,
  STEP_KEY.GivingAndContribution,
  STEP_KEY.Spiritual,
  STEP_KEY.HealthAndWellness,
  STEP_KEY.LocationToLive,
  STEP_KEY.Peers,
  STEP_KEY.Therapist,
  STEP_KEY.Stakeholders,
  STEP_KEY.Manager,
  STEP_KEY.Mentors,
  STEP_KEY.MyBoardOfDirectors,
  STEP_KEY.AccountabilityGroupCoworking,
  STEP_KEY.GroupCoworking,
  STEP_KEY.GroupCoaching,
  STEP_KEY.GroupMeditation,
  STEP_KEY.DiscussionBoard,
  STEP_KEY.AccountabilityTriads,
  STEP_KEY.PeerCoaching,
  STEP_KEY.AnnualGoalBuddy,
  STEP_KEY.ReadingBuddy,
  STEP_KEY.Settings,
  STEP_KEY.Security,
  STEP_KEY.MyPlan,
  STEP_KEY.Billing,
  STEP_KEY.Integrations,
  STEP_KEY.ShareFeedback,
  // STEP_KEY.PrivacyPolicy,
  // STEP_KEY.Logout,
  STEP_KEY.Assessment,
  STEP_KEY.TargetRoles,
  STEP_KEY.TargetIndustries,
  STEP_KEY.ResearchRoles,
  STEP_KEY.ResearchIndustries,
  STEP_KEY.ResearchAddNew,
  STEP_KEY.Contacts,
  STEP_KEY.EmailDrafts,
  STEP_KEY.Tracker,
  STEP_KEY.CallPrep,
  STEP_KEY.CallNotes,
  STEP_KEY.NetworkingReflections,
  STEP_KEY.NetworkingAddNew,
  STEP_KEY.LearningOpportunities,
  STEP_KEY.ExperiencesAddNew,
  STEP_KEY.ProfessionalSummary,
  STEP_KEY.Resume,
  STEP_KEY.CoverLetter,
  STEP_KEY.Linkedin,
  STEP_KEY.ApplicationTracker,
  STEP_KEY.InterviewResearch,
  STEP_KEY.InterviewPractice,
  STEP_KEY.Reflections,
  STEP_KEY.JobSearchAddNew,
  STEP_KEY.CompareRoles,
  STEP_KEY.PieChartExercise
];

const canBeNotified = (stepKey) => order.indexOf(stepKey) !== -1;

const stepOrder = (stepKey) => order.indexOf(stepKey);

const subSteps = {
  MY_COACH: [
    {
      title: "Agenda",
      linkTo: "/agenda",
      key: "29",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      stepKey: STEP_KEY.Agenda,
    },
    {
      title: "Coach Meetings",
      linkTo: "/coach-meetings",
      key: "30",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      stepKey: STEP_KEY.CoachMeetings,
    },
    {
      title: "Meeting Notes",
      linkTo: "/meeting-notes",
      key: "31",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      stepKey: STEP_KEY.MeetingNotes,
    },
    {
      title: "Coach Feedback",
      linkTo: "/coach-feedback",
      key: "32",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      stepKey: STEP_KEY.CoachFeedback,
    },
  ],
  LIFE_COACHING: [
    {
      title: "Mission Statement",
      key: "33",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to craft your personal mission statement, including which roles you play in your life and how you want to show up in each role.",
      linkTo: "/mission-statement",
      stepKey: STEP_KEY.MissionStatement,
    },
    {
      title: "Life Wheel",
      key: "34",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to divide the key areas of your overall focus and assess progress in each area.",
      linkTo: "/life-wheel",
      stepKey: STEP_KEY.LifeWheel,
    },
    {
      title: "Annual Goals",
      key: "35",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set and track your top personal goals for the upcoming year.",
      linkTo: "/annual-goals",
      stepKey: STEP_KEY.AnnualGoals,
    },
    {
      title: "Financial Management",
      key: "36",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track your personal finances.",
      linkTo: "/financial-management",
      stepKey: STEP_KEY.FinancialManagement,
    },
    {
      title: "Relationship Management",
      key: "37",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set goals for improving your personal relationships.",
      linkTo: "/relationship-management",
      stepKey: STEP_KEY.RelationshipManagement,
    },
    {
      title: "Travel & Adventure",
      key: "38",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set goals and track your travel goals or pursuits.",
      linkTo: "/travel-and-adventure",
      stepKey: STEP_KEY.TravelAndAdventure,
    },
    {
      title: "Giving & Contribution",
      key: "39",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track charities, volunteering, or other ways of giving back.",
      linkTo: "/giving-and-contribution",
      stepKey: STEP_KEY.GivingAndContribution,
    },
    {
      title: "Spiritual",
      key: "40",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to stay in touch with your spiritual side.",
      linkTo: "/Spiritual",
      stepKey: STEP_KEY.Spiritual,
    },
    {
      title: "Health & Wellness",
      key: "41",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set and track health, nutrition, and fitness goals.",
      linkTo: "/health-and-wellness",
      stepKey: STEP_KEY.HealthAndWellness,
    },
    {
      title: "Location to Live",
      key: "42",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to assess and compare different locations you are considering living in.",
      linkTo: "/location-to-live",
      stepKey: STEP_KEY.LocationToLive,
    },
  ],
  MY_SUPPORT_SYSTEM : [
    {
      title: "Peers",
      key: "43",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/peers",
      stepKey: STEP_KEY.Peers,
    },
    {
      title: "Therapist",
      key: "44",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/therapist",
      stepKey: STEP_KEY.Therapist,
    },
    {
      title: "Stakeholders",
      key: "45",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/stakeholders",
      stepKey: STEP_KEY.Stakeholders,
    },
    {
      title: "Manager",
      key: "46",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/manager",
      stepKey: STEP_KEY.Manager,
    },
    {
      title: "Mentors",
      key: "47",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/mentors",
      stepKey: STEP_KEY.Mentors,
    },
    {
      title: "My Board of Directors",
      key: "48",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/my-board-of-directors",
      stepKey: STEP_KEY.MyBoardOfDirectors,
    },
  ],
  COMMUNITY: [
    {
      title: "Group Coworking",
      key: "49",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/group-coworking",
      stepKey: STEP_KEY.GroupCoworking,
    },
    {
      title: "Group Coaching",
      key: "50",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/group-coaching",
      stepKey: STEP_KEY.GroupCoaching,
    },
    {
      title: "Group Meditation",
      key: "51",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/group-meditation",
      stepKey: STEP_KEY.GroupMeditation,
    },
    {
      title: "Discussion Board",
      key: "52",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "https://join.slack.com/t/getwoken/shared_invite/zt-za3osi0k-Wbba2fYxJHUev9Dsam3Z3Q",
      stepKey: STEP_KEY.DiscussionBoard,
    },
    {
      title: "Accountability Triads",
      key: "53",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/accountability-triads",
      stepKey: STEP_KEY.AccountabilityTriads,
    },
    {
      title: "Peer Coaching",
      key: "54",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/peer-coaching",
      stepKey: STEP_KEY.PeerCoaching,
    },
    {
      title: "Annual Goal Buddy",
      key: "55",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/annual-goal-buddy",
      stepKey: STEP_KEY.AnnualGoalBuddy,
    },
    {
      title: "Reading Buddy",
      key: "56",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      linkTo: "/reading-buddy",
      stepKey: STEP_KEY.ReadingBuddy,
    },
  ],
  // ONBOARDING: [
  //   {
  //     title: "Commitment",
  //     linkTo: { pathname: "/onboarding", stepProps: { curr: 4 } },
  //     key: "1",
  //     showStatusIcon: false,
  //   },
  //   {
  //     title: "Accountability",
  //     linkTo: { pathname: "/onboarding", stepProps: { curr: 5 } },
  //     key: "2",
  //     showStatusIcon: false,
  //   },
  //   {
  //     title: "Assessment",
  //     linkTo: "/assessment",
  //     key: "3",
  //     stepKey: STEP_KEY.Assessment,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Target Roles",
  //     linkTo: "/target-roles",
  //     key: "4",
  //     stepKey: STEP_KEY.TargetRoles,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Target Industries",
  //     linkTo: "/target-industries",
  //     key: "5",
  //     stepKey: STEP_KEY.TargetIndustries,
  //     showStatusIcon: true,
  //   },
  // ],
  CAREER_COACHING_MINDSET: [
    {
      title: "My Notebook",
      key: "74",
      linkTo: "/mindset/my-notebook",
      stepKey: STEP_KEY.MyNotebook,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Meditations",
      key: "75",
      linkTo: "/mindset/meditations",
      stepKey: STEP_KEY.Meditations,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Mindset Goals",
      key: "76",
      linkTo: "/mindset/mindset-goals",
      stepKey: STEP_KEY.MindsetGoals,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to identify and track goals that will alleviate limiting beliefs and enhance your mindset.",
    },
    {
      title: "Building Confidence",
      key: "77",
      linkTo: "/mindset/building-confidence",
      stepKey: STEP_KEY.BuildingConfidence,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to identify roadblocks and set goals to alleviate imposter syndrome and improve self-confidence.",
    },
    {
      title: "Envisioning Yourself",
      key: "78",
      linkTo: "/mindset/envisioning-yourself",
      stepKey: STEP_KEY.EnvisioningYourself,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to envision your ideal professional and personal future self.",
    },
    {
      title: "Influence Zones",
      key: "79",
      linkTo: "/mindset/influence-zones",
      stepKey: STEP_KEY.InfluenceZones,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to recognize what is in and out of your control, so you can gain a feeling of agency over your efforts and outcomes.",
    },
    {
      title: "Past Roles Reflection",
      key: "80",
      linkTo: "/mindset/past-roles-reflection",
      stepKey: STEP_KEY.PastRolesReflection,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to actively reflect on what was or was not a fit in your past roles to inform your next professional chapter.",
    },
    {
      title: "Networking Preparation",
      key: "81",
      linkTo: "/mindset/networking-preparation",
      stepKey: STEP_KEY.NetworkingPreparation,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to reflect and improve your mindset in order to gain comfort and confidence for professional networking.",
    },
  ],
  CAREER_COACHING_ACCOUNTABILITY: [
    {
      title: "My Commitment",
      key: "82",
      linkTo: "/accountability/onboarding",
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      stepKey: STEP_KEY.MyCommitment,
    },
    {
      title: "Progress Tracker",
      key: "83",
      linkTo: "/accountability/progress-tracker",
      stepKey: STEP_KEY.ProgressTracker,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "My Schedule",
      key: "84",
      linkTo: "/accountability/my-schedule",
      stepKey: STEP_KEY.AccountabilityMySchedule,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Suggested Schedule",
      key: "85",
      linkTo: "/accountability/suggested-schedule",
      stepKey: STEP_KEY.SuggestedSchedule,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "My Tasks",
      key: "86",
      linkTo: "/accountability/my-tasks",
      stepKey: STEP_KEY.MyTasks,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Group Coworking",
      key: "87",
      linkTo: "/accountability/group-coworking",
      stepKey: STEP_KEY.GroupCoworking,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
  ],
  CAREER_PATH_EXPLORATION: [
    {
      title: "Assessment",
      key: "88",
      linkTo: "/career-path-exploration/assessment",
      stepKey: STEP_KEY.Assessment,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
    },
    // {
    //   title: "Target Roles/Industries",
    //   key: "89",
    //   linkTo: "/career-path-exploration/target-roles-and-industries",
    //   stepKey: STEP_KEY.TargetRolesAndIndustries,
    //   // stepKey: STEP_KEY.TargetIndustries,
    //   showStatusIcon: true,
    //   showRequestAccess: true,
    //   newMenuOption: false,
    //   hoverText: "This tool is the follow-on after you complete your assessment, to translate your interests and strengths into potential roles and industries.",
    // },
    {
      title: "Target Roles",
      key: "4",
      linkTo: "/career-path-exploration/target-roles",
      // stepKey: STEP_KEY.TargetRolesAndIndustries,
      stepKey: STEP_KEY.TargetRoles,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool is the follow-on after you complete your assessment, to translate your interests and strengths into potential roles.",
    },
    {
      title: "Target Industries",
      key: "5",
      linkTo: "/career-path-exploration/target-industries",
      // stepKey: STEP_KEY.TargetRolesAndIndustries,
      stepKey: STEP_KEY.TargetIndustries,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool is the follow-on after you complete your assessment, to translate your interests and strengths into potential industries.",
    },
    {
      title: "Role Research",
      key: "90",
      linkTo: "/career-path-exploration/role-research",
      stepKey: STEP_KEY.ResearchRoles,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to gather information and organize your learnings about your target roles.",
    },
    {
      title: "Industry Research",
      key: "91",
      linkTo: "/career-path-exploration/industry-research",
      stepKey: STEP_KEY.ResearchIndustries,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to gather information and organize your learnings about your target industries.",
    },
    {
      title: "Networking",
      sectionHeader: true,
      linkTo: "#",
      key: "sub3_3_1_1",
      showStatusIcon: false,
      showRequestAccess: false,
      subMenu: true,
      level: '3',
      subSubStep:[
        {
          title: "Contacts Brainstorm",
          key: "148",
          linkTo: "/career-path-exploration/contacts-brainstorm",
          stepKey: STEP_KEY.Contacts,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: false,
          hoverText: "This tool allows you to become more open-minded in brainstorming who is in your network and how to use LinkedIn to research connections.",
        },
        {
          title: "Outreach Drafts",
          key: "149",
          linkTo: "/career-path-exploration/outreach-drafts",
          stepKey: STEP_KEY.EmailDrafts,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: false,
          hoverText: "This tool allows you to craft compelling outreach messages, ensuring that your language is clear, thoughtful, and customized.",
        },
        {
          title: "Networking Tracker",
          key: "150",
          linkTo: "/career-path-exploration/networking-tracker",
          stepKey: STEP_KEY.Tracker,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: false,
          hoverText: "This tool allows you to organize and track your networking outreach, follow ups, calls, notes, and more.",
        },
        {
          title: "Call Prep",
          key: "175",
          linkTo: "/career-path-exploration/call-prep",
          stepKey: STEP_KEY.CallPrep,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: false,
          hoverText: "This tool allows you to adequately prepare for upcoming networking calls to ensure you make the most of the call via research and framing questions.",
        },
        {
          title: "Reflections",
          key: "151",
          linkTo: "/career-path-exploration/reflections",
          stepKey: STEP_KEY.NetworkingReflections,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: false,
          hoverText: "This tool allows you to synthesize what you have been learning on your networking calls and identify next steps.",
        },
      ]
    },
    {
      title: "Compare Roles",
      key: "92",
      linkTo: "/career-path-exploration/compare-roles",
      stepKey: STEP_KEY.CompareRoles,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to compare, contrast, and prioritize which of your target roles is the best fit for you.",
    },
    {
      title: "Pie Chart Exercise",
      key: "93",
      linkTo: "/career-path-exploration/pie-chart-exercise",
      stepKey: STEP_KEY.PieChartExercise,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to dream up your ideal workweek, how you'd prefer to divide your time, and compare against your target roles.",
    },
    {
      title: "Resume Vision Exercise",
      key: "94",
      linkTo: "/career-path-exploration/resume-vision-exercise",
      stepKey: STEP_KEY.ResumeVisionExercise,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to envision what your future resume should look like, which will inform what you want out of your next role.",
    },
    {
      title: "Key Definitions",
      key: "95",
      linkTo: "/career-path-exploration/key-definitions",
      stepKey: STEP_KEY.KeyDefinitions,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track and define jargon and key terms that may be new to you if you're exploring new roles or industries.",
    },
    {
      title: "Identify Gaps",
      key: "96",
      linkTo: "/career-path-exploration/identify-gaps",
      stepKey: STEP_KEY.IdentifyGaps,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to reflect on how you're feeling about your target roles so far, your concerns, hesitations, or questions, and next steps.",
    },
    {
      title: "Career Trajectory",
      key: "97",
      linkTo: "/career-path-exploration/career-trajectory",
      stepKey: STEP_KEY.CareerTrajectory,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
  ],
  UPSKILLING: [
    {
      title: "Research",
      sectionHeader: true,
      linkTo: "#",
      showStatusIcon: false,
      showRequestAccess: false,
    },
    {
      title: "Strengths Overview",
      key: "98",
      linkTo: "/upskilling/strengths-overview",
      stepKey: STEP_KEY.StrengthsOverview,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool guides you to articulate what you're great at vs. good at vs. would be great at vs. want to learn more of vs. not great at, and more.",
    },
    {
      title: "Skill Gap Analysis",
      key: "99",
      linkTo: "/upskilling/skill-gap-analysis",
      stepKey: STEP_KEY.SkillGapAnalysis,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to document the necessary skills for your target role and compare to your current skill set, to identify and prioritize skill gaps.",
    },
    {
      title: "Job Posting Exercise",
      key: "100",
      linkTo: "/upskilling/job-posting-exercise",
      stepKey: STEP_KEY.JobPostingExercise,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to make sense of a job posting to clarify your fit with and interest in the role.",
    },
    {
      title: "Upskilling Tracker",
      key: "101",
      linkTo: "/upskilling/upskilling-tracker",
      stepKey: STEP_KEY.LearningOpportunities,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to track potential upskilling efforts and brainstorm the variety of ways to get hands-on experience in your desired fields.",
    },
    {
      title: "Compare Options",
      key: "102",
      linkTo: "/upskilling/compare-options",
      stepKey: STEP_KEY.CompareOptions,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to understand and compare various hands-on learning program options to identify which one is the best for you to pursue.",
    },
    {
      title: "Education Planning",
      key: "176",
      linkTo: "/upskilling/education-planning",
      stepKey: STEP_KEY.EducationPlanning,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to create a roadmap that clarifies the steps towards identifying fitting programs and drafting and submitting strong applications.",
    },
    {
      title: "My Credentials",
      key: "103",
      linkTo: "/upskilling/my-credentials",
      stepKey: STEP_KEY.MyCredentials,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track your previous educational achievements and your options for potential further certifications or degrees.",
    },
    {
      title: "Key Links",
      key: "104",
      linkTo: "/upskilling/key-links",
      stepKey: STEP_KEY.KeyLinks,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Soft Skill Development",
      key: "105",
      linkTo: "/upskilling/soft-skill-development",
      stepKey: STEP_KEY.SoftSkillDevelopment,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track your efforts and goals to advance your interpersonal skills.",
    },
    {
      title: "Develop Skills",
      sectionHeader: true,
      linkTo: "#",
      showStatusIcon: false,
      showRequestAccess: false,
    },
    {
      title: "Boundary Setting",
      key: "106",
      linkTo: "/upskilling/boundary-setting",
      stepKey: STEP_KEY.BoundarySetting,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to work on setting boundaries with others.",
    },
    {
      title: "Communication",
      key: "107",
      linkTo: "/upskilling/communication",
      stepKey: STEP_KEY.Communication,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to identify areas for improvement with your communication and advance your communication skills.",
    },
    {
      title: "Time Management",
      key: "108",
      linkTo: "/upskilling/time-management",
      stepKey: STEP_KEY.TimeManagement,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to reflect and strengthen your plans to better manage your time. Don't forget to check out the <strong><i>My Schedule</i></strong> tab too!",
    },
    {
      title: "Project Management",
      key: "109",
      linkTo: "/upskilling/project-management",
      stepKey: STEP_KEY.ProjectManagement,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to enhance your skills in overseeing and leading successful, on-time, on-budget projects.",
    },
    {
      title: "Improving Focus",
      key: "110",
      linkTo: "/upskilling/improving-focus",
      stepKey: STEP_KEY.ImprovingFocus,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to brainstorm ways to help you stay organized, productive, and on track towards your key priorities.",
    },
    {
      title: "Influence & Visibility",
      key: "111",
      linkTo: "/upskilling/influence-and-visibility",
      stepKey: STEP_KEY.InfluenceAndVisibility,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to increase your involvement and share your achievements across your firm as well as attain sponsorship or mentorship.",
    },
  ],
  PERSONAL_BRANDING: [
    {
      title: "Professional Summary",
      key: "112",
      linkTo: "/personal-branding/professional-summary",
      stepKey: STEP_KEY.ProfessionalSummary,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to generate a concise overview of who you are as a professional so that you can own your story.",
    },
    {
      title: "Resume",
      key: "113",
      linkTo: "/personal-branding/resume",
      stepKey: STEP_KEY.Resume,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to review and apply best practices to your resume, ensuring your document is clean and strong.",
    },
    {
      title: "Linkedin Profile",
      key: "114",
      linkTo: "/personal-branding/linkedin-profile",
      stepKey: STEP_KEY.Linkedin,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to review and apply best practices to your LinkedIn profile, optimizing keywords to increase the chance for inbound leads.",
    },
    {
      title: "Cover Letter",
      key: "115",
      linkTo: "/personal-branding/cover-letter",
      stepKey: STEP_KEY.CoverLetter,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to answer key questions about your background that will auto-generate a cover letter.",
    },
    {
      title: "Video Pitch",
      key: "116",
      linkTo: "/personal-branding/video-pitch",
      stepKey: STEP_KEY.VideoPitch,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to plan and record a 1-minute pitch to share your professional background in video format, to help you go beyond the resume.",
    },
    {
      title: "Portfolio/Website",
      key: "117",
      linkTo: "/personal-branding/portfolio-or-website",
      stepKey: STEP_KEY.PortfolioOrWebsite,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to plan a professional portfolio or personal website so that you can more creatively, visually represent your background.",
    },
    {
      title: "Thought Leadership",
      key: "118",
      linkTo: "/personal-branding/thought-leadership",
      stepKey: STEP_KEY.ThoughtLeadership,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to plan and create content to share your expertise on social media (blogs, case studies, videos, sharing tips, or other).",
    },
    {
      title: "ATS Keywords",
      key: "119",
      linkTo: "/personal-branding/ats-keywords",
      stepKey: STEP_KEY.ATSKeywords,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track keywords that you need to incorporate into your resume and LinkedIn profile that align with your target roles.",
    },
  ],
  NETWORKING: [
    {
      title: "Mindset Preparation",
      key: "120",
      linkTo: "/networking/mindset-preparation",
      stepKey: STEP_KEY.NetworkingPreparation,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to reflect and improve your mindset in order to gain comfort and confidence for professional networking.",
    },
    {
      title: "Places to Network",
      key: "121",
      linkTo: "/networking/places-to-network",
      stepKey: STEP_KEY.PlacesToNetwork,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to brainstorm various groups or places where you can meet people who align with your target roles, industries, or demographics."
    },
    {
      title: "Contacts Brainstorm",
      key: "122",
      linkTo: "/networking/contacts-brainstorm",
      stepKey: STEP_KEY.Contacts,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to become more open-minded in brainstorming who is in your network and how to use LinkedIn to research connections.",
    },
    {
      title: "Outreach Drafts",
      key: "123",
      linkTo: "/networking/outreach-drafts",
      stepKey: STEP_KEY.EmailDrafts,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to craft compelling outreach messages, ensuring that your language is clear, thoughtful, and customized.",
    },
    {
      title: "Networking Tracker",
      key: "124",
      linkTo: "/networking/networking-tracker",
      stepKey: STEP_KEY.Tracker,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to organize and track your networking outreach, follow ups, calls, notes, and more.",
    },
    {
      title: "Call Prep",
      key: "11",
      linkTo: "/networking/call-prep",
      stepKey: STEP_KEY.CallPrep,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to adequately prepare for upcoming networking calls to ensure you make the most of the call via research and framing questions.",
    },
    {
      title: "Call Notes",
      key: "12",
      linkTo: "/networking/call-notes",
      stepKey: STEP_KEY.CallNotes,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to review your prepared questions and take notes during a networking call.",
    },
    {
      title: "Reflections",
      key: "13",
      linkTo: "/networking/reflections",
      stepKey: STEP_KEY.NetworkingReflections,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to synthesize what you have been learning on your networking calls and identify next steps.",
    },
  ],
  JOB_SEARCHING: [
    {
      title: "Progress Tracker",
      key: "152",
      linkTo: "/job-searching/progress-tracker",
      stepKey: STEP_KEY.JobSearchingProgressTracker,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to understand key job search activities, set daily or weekly goals for each, and track your progress against each goal.",
    },
    {
      title: "Strategy and Direction",
      key: "153",
      linkTo: "/job-searching/strategy-and-direction",
      stepKey: STEP_KEY.StrategyAndDirection,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to synthesize your direction for your next gig: your target role titles, target industries/companies, size of company, and location.",
    },
    {
      title: "My Schedule",
      key: "154",
      linkTo: "/job-searching/my-schedule",
      stepKey: STEP_KEY.MySchedule,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set your daily and weekly schedule for job search activities to ensure you plan your time wisely and intentionally.",
    },
    {
      title: "Suggested Schedule",
      key: "155",
      linkTo: "/job-searching/suggested-schedule",
      stepKey: STEP_KEY.JobSearchingSuggestedSchedule,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to see a suggested job search schedule of the most recommended activities. Reference this when building your own weekly plans.",
    },
    {
      title: "Job Search Tracker",
      key: "156",
      linkTo: "/job-searching/job-search-tracker",
      // stepKey: STEP_KEY.JobSearchTracker,
      stepKey: STEP_KEY.ApplicationTracker,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: false,
      hoverText: "This tool allows you to track your job search efforts including applications, associated networking, follow ups, and more.",
    },
    {
      title: "Target Job Postings",
      key: "157",
      linkTo: "/job-searching/target-job-postings",
      stepKey: STEP_KEY.TargetJobPostings,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track the job postings you want to apply for.",
    },
    {
      title: "Target Companies",
      key: "158",
      linkTo: "/job-searching/target-companies",
      stepKey: STEP_KEY.TargetCompanies,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to keep a list handy of companies you want to work for and can proactively target.",
    },
    {
      title: "Staffing Agencies",
      key: "159",
      linkTo: "/job-searching/staffing-agencies",
      stepKey: STEP_KEY.StaffingAgencies,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to learn about existing staffing agencies and track your communications with them.",
    },
    {
      title: "Visa Resources",
      key: "160",
      linkTo: "/job-searching/visa-resources",
      stepKey: STEP_KEY.VisaResources,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track resources that help you attain or manage your visa process.",
    },
    {
      title: "Set Priorities",
      key: "161",
      linkTo: "/job-searching/set-priorities",
      stepKey: STEP_KEY.SetPriorities,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to clarify what you want out of your next work opportunity, i.e. role, team, company, industry, growth, benefits/perks, and more.",
    },
    {
      title: "Interview Preparation",
      sectionHeader: true,
      linkTo: "#",
      key: "sub3_3_5_1",
      showStatusIcon: false,
      showRequestAccess: false,
      subMenu: true,
      level: '3',
      subSubStep:[
        {
          title: "Interview Research",
          key: "162",
          linkTo: "/job-searching/interview-research",
          stepKey: STEP_KEY.InterviewResearch,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to prepare for upcoming interviews by researching the role, team, company, industry, and brainstorming questions to ask.",
        },
        {
          title: "Interview Responses",
          key: "163",
          linkTo: "/job-searching/interview-responses",
          stepKey: STEP_KEY.InterviewPractice,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to prepare for upcoming interviews by preparing responses and stories for expected interview questions.",
        },
        {
          title: "Questions to Ask",
          key: "164",
          linkTo: "/job-searching/questions-to-ask",
          stepKey: STEP_KEY.QuestionsToAsk,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to list your criteria for your next role or company and translate those into creative questions to assess their fit with your priorities.",
        },
        {
          title: "Mock Interview",
          key: "165",
          linkTo: "/job-searching/mock-interview",
          stepKey: STEP_KEY.MockInterview,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to schedule, prepare for, and run mock interviews.",
        },
        {
          title: "Case Interview",
          key: "166",
          linkTo: "/job-searching/case-interview",
          stepKey: STEP_KEY.CaseInterview,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to schedule, prepare for, and run case interviews. Case interviews are often specific to consulting or other fields.",
        },
        {
          title: "Technical Interview",
          key: "167",
          linkTo: "/job-searching/technical-interview",
          stepKey: STEP_KEY.TechnicalInterview,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to schedule, prepare for, and run technical mock interviews.",
        },
        {
          title: "Interview Follow-Ups",
          key: "168",
          linkTo: "/job-searching/interview-follow-ups",
          stepKey: STEP_KEY.InterviewFollowUps,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to draft and track thoughtful follow up messages to be sent after any recent interview.",
        },
        {
          title: "Standing Out",
          key: "169",
          linkTo: "/job-searching/standing-out",
          stepKey: STEP_KEY.StandingOut,
          showStatusIcon: true,
          showRequestAccess: true,
          newMenuOption: true,
          hoverText: "This tool allows you to review tips on creative ways to stand out during your interview process, whether it is during interviews or in your follow ups.",
        },
      ]
    },
    {
      title: "Offer Analysis",
      key: "170",
      linkTo: "/job-searching/offer-analysis",
      stepKey: STEP_KEY.OfferAnalysis,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to compare, analyze, and make decisions on offers, depending on how well the job offer aligns with your priorities.",
    },
    {
      title: "Salary Research",
      key: "171",
      linkTo: "/job-searching/salary-research",
      stepKey: STEP_KEY.SalaryResearch,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to research and understand the average, market salary ranges for your target role, industry, and location.",
    },
    {
      title: "Reflections",
      key: "172",
      linkTo: "/job-searching/reflections",
      stepKey: STEP_KEY.Reflections,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to reflect on how your job search is going qualitatively and quantitatively, so that you can measure results and pivot often.",
    },
    {
      title: "Key Links",
      key: "173",
      linkTo: "/job-searching/key-links",
      stepKey: STEP_KEY.JobSearchingKeyLinks,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Helpful Tools",
      key: "174",
      linkTo: "/job-searching/helpful-tools",
      stepKey: STEP_KEY.HelpfulTools,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
  ],
  EVENTS: [
    {
      title: "Past Events",
      key: "125",
      linkTo: "/events/past-events",
      stepKey: STEP_KEY.PastEvents,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Upcoming Events",
      key: "126",
      linkTo: "/events/upcoming-events",
      stepKey: STEP_KEY.UpcomingEvents,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
    {
      title: "Find Events",
      key: "127",
      linkTo: "/events/find-events",
      stepKey: STEP_KEY.FindEvents,
      showStatusIcon: false,
      showRequestAccess: true,
      newMenuOption: true,
    },
  ],
  CAREER_ADVANCEMENTS: [
    {
      title: "Onboarding 30/60/90",
      key: "128",
      linkTo: "/career-advancement/onboarding-30-60-90",
      stepKey: STEP_KEY.Onboarding_30_60_90,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool gives you a template to track your efforts during your first 90 days at work to set yourself up for success in a new role.",
    },
    {
      title: "Onboarding Checklist",
      key: "129",
      linkTo: "/career-advancement/onboarding-checklist",
      stepKey: STEP_KEY.OnboardingChecklist,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool provides a checklist for onboarding best practices to set yourself up for success in a new role.",
    },
    {
      title: "Promotions",
      key: "130",
      linkTo: "/career-advancement/promotions",
      stepKey: STEP_KEY.Promotions,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool guides you to identify necessary goals to hit in order to get promoted and to track and share progress against these goals.",
    },
    {
      title: "Internal Mobility",
      key: "131",
      linkTo: "/career-advancement/internal-mobility",
      stepKey: STEP_KEY.InternalMobility,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool guides you through the process of exploring and pursuing collaboration with other teams or a role on another internal team at your company.",
    },
    {
      title: "Performance Reviews",
      key: "132",
      linkTo: "/career-advancement/performance-reviews",
      stepKey: STEP_KEY.PerformanceReviews,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool guides you to how to accurately review yourself and your colleagues, and to prepare for performance review conversations.",
    },
    {
      title: "Job Expectations",
      key: "133",
      linkTo: "/career-advancement/job-expectations",
      stepKey: STEP_KEY.JobExpectations,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool ensures that your role expectations are clear, ensuring you know what to strive for and that you get fair feedback.",
    },
    {
      title: "Annual Goals",
      key: "134",
      linkTo: "/career-advancement/annual-goals",
      stepKey: STEP_KEY.CareerAdvencementsAnnualGoals,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to set and track your top developmental goals for the next year at work.",
    },
    {
      title: "Stakeholder Updates",
      key: "135",
      linkTo: "/career-advancement/stakeholder-updates",
      stepKey: STEP_KEY.StakeholderUpdates,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to craft and share periodic updates with key stakeholders at your company to ensure you stay visible.",
    },
    {
      title: "Track Achievements",
      key: "136",
      linkTo: "/career-advancement/track-achievements",
      stepKey: STEP_KEY.TrackAchievements,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track your wins, success stories, and projects at work, making it easier to update your resume when you are ready.",
    },
  ],
  ENTREPRENEURSHIP: [
    {
      title: "Roadmap",
      key: "137",
      linkTo: "/entrepreneurship/roadmap",
      stepKey: STEP_KEY.Roadmap,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to create a high level roadmap or phased plan to launch or grow your new venture.",
    },
    {
      title: "Customer Personas",
      key: "138",
      linkTo: "/entrepreneurship/customer-personas",
      stepKey: STEP_KEY.CustomerPersonas,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to identify and define your potential types of customer groups.",
    },
    {
      title: "Market Research",
      key: "139",
      linkTo: "/entrepreneurship/market-research",
      stepKey: STEP_KEY.MarketResearch,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to more deeply understand your customers and market trends.",
    },
    {
      title: "Define Offerings",
      key: "140",
      linkTo: "/entrepreneurship/define-offerings",
      stepKey: STEP_KEY.DefineOfferings,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to define your product or service offerings, what is included, and pricing.",
    },
    {
      title: "Financials",
      key: "141",
      linkTo: "/entrepreneurship/financials",
      stepKey: STEP_KEY.Financials,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track your company's budget and financial projections.",
    },
    {
      title: "Marketing",
      key: "142",
      linkTo: "/entrepreneurship/marketing",
      stepKey: STEP_KEY.Marketing,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to brainstorm and prioritize various distribution channels and methods to market your services to your customers.",
    },
    {
      title: "Sales",
      key: "143",
      linkTo: "/entrepreneurship/sales",
      stepKey: STEP_KEY.Sales,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to define your sales process, house your CRM, enhance your sales training and acumen, and track sales data.",
    },
    {
      title: "Product Development",
      key: "144",
      linkTo: "/entrepreneurship/product-development",
      stepKey: STEP_KEY.ProductDevelopment,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to plan the advancements to your product or serving offering.",
    },
    {
      title: "Team Management",
      key: "145",
      linkTo: "/entrepreneurship/team-management",
      stepKey: STEP_KEY.TeamManagement,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to create an organizational chart for the various roles on your team and track your team members or hiring efforts.",
    },
    {
      title: "Legal",
      key: "146",
      linkTo: "/entrepreneurship/legal",
      stepKey: STEP_KEY.Legal,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to track contracts, NDA's, legal to do lists, save key links or contact information, and more. ",
    },
    {
      title: "Operations",
      key: "147",
      linkTo: "/entrepreneurship/operations",
      stepKey: STEP_KEY.Operations,
      showStatusIcon: true,
      showRequestAccess: true,
      newMenuOption: true,
      hoverText: "This tool allows you to build procedure manuals, automate processes, track user flows, and create efficiencies.",
    },
  ],
  // EXPLORATION_RESEARCH: [
  //   {
  //     title: "Roles",
  //     key: "6",
  //     linkTo: "/research-roles",
  //     stepKey: STEP_KEY.ResearchRoles,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Industries",
  //     key: "7",
  //     linkTo: "/research-industries",
  //     stepKey: STEP_KEY.ResearchIndustries,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "+ Add New",
  //     key: "24",
  //     linkTo: "#",
  //     stepKey: STEP_KEY.ResearchAddNew,
  //     showStatusIcon: false,
  //   },
  // ],
  // EXPLORATION_NETWORKING: [
  //   {
  //     title: "Contacts",
  //     key: "8",
  //     linkTo: "/networking/contacts",
  //     stepKey: STEP_KEY.Contacts,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Email Drafts",
  //     key: "9",
  //     linkTo: "/networking/email-drafts",
  //     stepKey: STEP_KEY.EmailDrafts,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Tracker",
  //     key: "10",
  //     linkTo: "/networking/tracker",
  //     stepKey: STEP_KEY.Tracker,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Call Prep",
  //     key: "11",
  //     linkTo: "/networking/call-prep",
  //     stepKey: STEP_KEY.CallPrep,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Call Notes",
  //     key: "12",
  //     linkTo: "/networking/call-notes",
  //     stepKey: STEP_KEY.CallNotes,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Reflections",
  //     key: "13",
  //     linkTo: "/networking/reflections",
  //     stepKey: STEP_KEY.NetworkingReflections,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "+ Add New",
  //     key: "25",
  //     linkTo: "#",
  //     stepKey: STEP_KEY.NetworkingAddNew,
  //     showStatusIcon: false,
  //   },
  // ],
  // EXPLORATION_EXPERIENCES: [
  //   {
  //     title: "Learning Opportunities",
  //     key: "14",
  //     linkTo: "/learning-opportunities",
  //     stepKey: STEP_KEY.LearningOpportunities,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "+ Add New",
  //     key: "26",
  //     linkTo: "#",
  //     stepKey: STEP_KEY.ExperiencesAddNew,
  //     showStatusIcon: false,
  //   },
  // ],
  // EXECUTION_MATERIALS: [
  //   {
  //     title: "Professional Summary",
  //     key: "15",
  //     linkTo: "/materials/professional-summary",
  //     stepKey: STEP_KEY.ProfessionalSummary,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Resume",
  //     key: "16",
  //     linkTo: "/materials/resume",
  //     stepKey: STEP_KEY.Resume,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Cover Letter",
  //     key: "17",
  //     linkTo: "/materials/cover-letter",
  //     stepKey: STEP_KEY.CoverLetter,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Linkedin",
  //     key: "18",
  //     linkTo: "/materials/linkedin",
  //     stepKey: STEP_KEY.Linkedin,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "+ Add New",
  //     key: "27",
  //     linkTo: "#",
  //     stepKey: STEP_KEY.MaterialsAddNew,
  //     showStatusIcon: false,
  //   },
  // ],
  // EXECUTION_JOB_SEARCH: [
  //   {
  //     title: "Application Tracker",
  //     key: "19",
  //     linkTo: "/job-search/application-tracker",
  //     stepKey: STEP_KEY.ApplicationTracker,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Interview Research",
  //     key: "20",
  //     linkTo: "/job-search/interview-research",
  //     stepKey: STEP_KEY.InterviewResearch,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Interview Practice",
  //     key: "21",
  //     linkTo: "/job-search/interview-prep",
  //     stepKey: STEP_KEY.InterviewPractice,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "Reflections",
  //     key: "22",
  //     linkTo: "/job-search/reflections",
  //     stepKey: STEP_KEY.Reflections,
  //     showStatusIcon: true,
  //   },
  //   {
  //     title: "+ Add New",
  //     key: "28",
  //     linkTo: "#",
  //     stepKey: STEP_KEY.JobSearchAddNew,
  //     showStatusIcon: false,
  //   },
  // ],
  // DASHBOARD: [
  //   {
  //     title: "Dashboard",
  //     linkTo: "/dashboard",
  //     key: "0",
  //     showStatusIcon: false,
  //   }
  // ],
  CALENDAR: [
    {
      title: "Calendar",
      linkTo: "/calendar",
      key: "23",
      showStatusIcon: false,
    }
  ],
  RESOURCES: [
    {
      title: "WOKEN Videos & Meditations",
      linkTo: "https://www.youtube.com/channel/UCzENh4CtxdGdnsABkLHeAAg",
      key: "24",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.WOKENVideosMeditations
    },
    {
      title: "Other Videos",
      linkTo: "/other-videos",
      key: "57",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.OtherVideos
    },
    {
      title: "WOKEN Book",
      linkTo: "https://drive.google.com/file/d/1r0_pYv6MpTNXKBxlhK0aU9TjadZzMyOO/view",
      key: "25",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.WOKENBook
    },
    {
      title: "Other Books",
      linkTo: "/other-books",
      key: "58",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.OtherBooks
    },
    {
      title: "WOKEN Blogs",
      linkTo: "https://www.iamwoken.com/resources",
      key: "26",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.WOKENBlogs
    },
    {
      title: "Other Blogs",
      linkTo: "/other-blogs",
      key: "59",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.OtherBlogs
    },
    {
      title: "WOKEN Workshops",
      linkTo: "https://www.iamwoken.com/resources",
      key: "60",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.WOKENWorkshops
    },
    {
      title: "Podcasts",
      linkTo: "/podcasts",
      key: "61",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Podcasts
    },
    {
      title: "Templates",
      linkTo: "/templates",
      key: "62",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Templates
    },
    {
      title: "FAQ's",
      linkTo: "https://docs.google.com/document/d/12C7ZbxUvSIIRQuxkPt304th27gfPdHgxvDMiiZ8LCQU/edit?usp=sharing",
      key: "63",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.FAQ
    },
    {
      title: "Whiteboard",
      linkTo: "/whiteboard",
      key: "64",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Whiteboard,
    },
    {
      title: "Key Links",
      linkTo: "/key-links",
      key: "65",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.KeyLinksJob
    },
  ],
  PROFILE: [
    {
      title: "Settings",
      key: "66",
      linkTo: "/settings",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Settings,
    },
    {
      title: "Security",
      key: "67",
      linkTo: "/security",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Security,
    },
    {
      title: "My Plan",
      key: "68",
      linkTo: "/my-plan",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.MyPlan,
    },
    {
      title: "Billing",
      key: "69",
      linkTo: "/billing",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Billing,
    },
    {
      title: "Integrations",
      key: "70",
      linkTo: "/integrations",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.Integrations,
    },
    {
      title: "Share Feedback",
      key: "71",
      linkTo: "",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: true,
      stepKey: STEP_KEY.ShareFeedback,
      onClick: () => {
        if (window.Ybug) {
          window.Ybug.open();  // Open Ybug if available
        } else {
          console.error("Ybug is not initialized yet"); // Error handling
        }
      }
    },
    {
      title: "Privacy Policy",
      key: "72",
      linkTo: "/profile/privacy-policy",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.PrivacyPolicy,
    },
    {
      title: "Logout",
      key: "73",
      linkTo: "#",
      showStatusIcon: false,
      showRequestAccess: false,
      newMenuOption: false,
      stepKey: STEP_KEY.Logout,
      onClick: (e) => {
        e.stopPropagation();
        Modal.confirm({
          title: "Confirm Logout !!",
          content: "Are you sure you want to logout?",
          okText: "Yes",
          cancelText: "No",
          maskClosable: true,
          onOk: () => {
            localStorage.removeItem("token");
            localStorage.removeItem("isCoach");
            window.heap.resetIdentity();
            window.location.href = "/signin";
          }
        });
        setTimeout(() => {
          const modalElements = document.querySelectorAll(".ant-modal");
          const latestModal = modalElements[modalElements.length - 1];
          if (latestModal) latestModal.setAttribute("data-modal-id", "logout-modal");
          const btnElement = document.querySelector('.ant-modal[data-modal-id="logout-modal"] .ant-btn:not(ant-btn-primary)');
          btnElement.setAttribute("type", "primary");
          btnElement.classList.add('button-secondary')
          btnElement.classList.remove('ant-btn')

          const btnElement2 = document.querySelector('.ant-modal[data-modal-id="logout-modal"] .ant-btn.ant-btn-primary');
          btnElement2.setAttribute("type", "primary");
          btnElement2.classList.add('button-main')
          btnElement2.classList.remove('ant-btn')
          btnElement2.classList.remove('ant-btn-primary')
        }, 0);
      },
    },
  ],
};

const steps = [
  {
    title: "Dashboard",
    key: "sub1",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboard.svg",
    linkTo: "/dashboard",
    level: "0",
    subSteps: [
      // {
      //   steps: subSteps.DASHBOARD,
      // },
    ],
  },
  {
    title: "My Coach",
    key: "sub2",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuMyCoach.svg",
    level: "0",
    subSteps: [
      {
        steps: subSteps.MY_COACH,
        level: "1",
      },
    ],
  },
  {
    title: "Career Coaching",
    key: "sub3",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/careerCoaching.svg",
    level: "0",
    subSteps: [
      {
        title: "Mindset",
        key: "sub3_1",
        steps: subSteps.CAREER_COACHING_MINDSET,
        level: "1",
      },
      {
        title: "Accountability",
        key: "sub3_2",
        steps: subSteps.CAREER_COACHING_ACCOUNTABILITY,
        level: "1",
      },
      {
        title: "Practical Strategies",
        key: "sub3_3",
        level: "1",
        // steps: subSteps.CAREER_COACHING_PRACTICAL_STRATEGIES,
        steps: [
          {
            title: "Career Path Exploration",
            key: "sub3_3_1",
            steps: subSteps.CAREER_PATH_EXPLORATION,
            level: "2",
          },
          {
            title: "Upskilling",
            key: "sub3_3_2",
            steps: subSteps.UPSKILLING,
            level: "2",
          },
          {
            title: "Personal Branding",
            key: "sub3_3_3",
            steps: subSteps.PERSONAL_BRANDING,
            level: "2",
          },
          {
            title: "Networking",
            key: "sub3_3_4",
            steps: subSteps.NETWORKING,
            level: "2",
          },
          {
            title: "Job Searching",
            key: "sub3_3_5",
            steps: subSteps.JOB_SEARCHING,
            level: "2",
          },
          {
            title: "Events",
            key: "sub3_3_6",
            steps: subSteps.EVENTS,
            level: "2",
          },
          {
            title: "Career Advancement",
            key: "sub3_3_7",
            steps: subSteps.CAREER_ADVANCEMENTS,
            level: "2",
          },
          {
            title: "Entrepreneurship",
            key: "sub3_3_8",
            steps: subSteps.ENTREPRENEURSHIP,
            level: "2",
          }
        ],
      },
    ],
  },
  {
    title: "Life Coaching",
    key: "sub4",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuLifeCoaching.svg",
    level: "0",
    subSteps: [
      {
        steps: subSteps.LIFE_COACHING,
        level: "1",
      },
    ],
  },
  {
    title: "My Support System",
    key: "sub5",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/mySupportSystem.svg",
    level: "0",
    subSteps: [
      {
        steps: subSteps.MY_SUPPORT_SYSTEM,
        level: "1",
      },
    ],
  },
  {
    title: "Community",
    key: "sub6",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuCommunity.svg",
    level: "0",
    subSteps: [
      {
        steps: subSteps.COMMUNITY,
        level: "1",
      },
    ],
  },
  {
    title: "Resources",
    key: "sub7",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/resources.svg",
    level: "0",
    subSteps: [
      {
       steps: subSteps.RESOURCES,
       level: "1",
      },
    ],
  },
  {
    title: "Profile",
    key: "sub8",
    icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuProfile.svg",
    level: "0",
    subSteps: [
      {
        steps: subSteps.PROFILE,
        level: "1",
      },
    ],
  },
  // {
  //   title: "Onboarding",
  //   key: "sub9",
  //   icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/careerCoaching.svg",
  //   level: "0",
  //   subSteps: [
  //     {
  //       steps: subSteps.ONBOARDING,
  //       key: "sub9_1",
  //       level: "1",
  //     },
  //   ],
  // },
  // {
  //   title: "Exploration",
  //   key: "sub10",
  //   icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/mySupportSystem.svg",
  //   level: "0",
  //   subSteps: [
  //     {
  //       title: "Research",
  //       key: "sub10_1",
  //       steps: subSteps.EXPLORATION_RESEARCH,
  //       level: "1",
  //     },
  //     {
  //       title: "Networking",
  //       key: "sub10_2",
  //       steps: subSteps.EXPLORATION_NETWORKING,
  //       level: "1",
  //     },
  //     {
  //       title: "Experiences",
  //       key: "sub10_3",
  //       steps: subSteps.EXPLORATION_EXPERIENCES,
  //       level: "1",
  //     },
  //   ],
  // },
  // {
  //   title: "Execution",
  //   key: "sub11",
  //   icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/lifeCoaching.svg",
  //   level: "0",
  //   subSteps: [
  //     {
  //       title: "Materials",
  //       key: "sub11_1",
  //       steps: subSteps.EXECUTION_MATERIALS,
  //       level: "1",
  //     },
  //     {
  //       title: "Job Search",
  //       key: "sub11_2",
  //       steps: subSteps.EXECUTION_JOB_SEARCH,
  //       level: "1",
  //     },
  //   ],
  // },
  // {
  //   title: "CALENDAR",
  //   key: "sub5",
  //   icon: "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/community.svg",
  //   linkTo: "/calendar",
  //   level: "0",
  //   subSteps: [
  //     // {
  //     //   steps: subSteps.CALENDAR,
  //     // },
  //   ],
  // },
];

const stepsAutoUnlockObj = {
  AG: {auto_unlock: true, name: "Agenda"},
  CM: {auto_unlock: true, name: "Coach Meetings"},
  ME: {auto_unlock: true, name: "Meeting Notes"},
  CF: {auto_unlock: true, name: "Coach Feedback"},
  MN: {auto_unlock: true, name: "My Notebook"},
  MD: {auto_unlock: true, name: "Meditations"},
  MG: {auto_unlock: true, name: "Mindset Goals"},
  BG: {auto_unlock: true, name: "Building Confidence"},
  EY: {auto_unlock: true, name: "Envisioning Yourself"},
  IZ: {auto_unlock: true, name: "Influence Zones"},
  RL: {auto_unlock: true, name: "Past Roles Reflection"},
  NN: {auto_unlock: false, name: "Networking Preparation"},
  MCM: {auto_unlock: true, name: "My Commitment"},
  PT: {auto_unlock: true, name: "Progress Tracker"},
  AMS: {auto_unlock: true, name: "My Schedule"},
  SS: {auto_unlock: true, name: "Suggested Schedule"},
  MT: {auto_unlock: true, name: "My Tasks"},
  GC: {auto_unlock: true, name: "Group Coworking"},
  MS: {auto_unlock: true, name: "Mission Statement"},
  LS: {auto_unlock: true, name: "Life Wheel"},
  AL: {auto_unlock: true, name: "Annual Goals"},
  FM: {auto_unlock: true, name: "Financial Management"},
  RM: {auto_unlock: true, name: "Relationship Management"},
  TN: {auto_unlock: true, name: "Travel & Adventure"},
  GT: {auto_unlock: true, name: "Giving & Contribution"},
  SR: {auto_unlock: true, name: "Spiritual"},
  HW: {auto_unlock: true, name: "Health & Wellness"},
  LT: {auto_unlock: true, name: "Location To Live"},
  PE: {auto_unlock: true, name: "Peers"},
  TH: {auto_unlock: true, name: "Therapist"},
  KH: {auto_unlock: true, name: "Stakeholders"},
  MA: {auto_unlock: true, name: "Manager"},
  MO: {auto_unlock: true, name: "Mentors"},
  MB: {auto_unlock: true, name: "My Board Of Directors"},
  GW: {auto_unlock: true, name: "Group Coworking"},
  GH: {auto_unlock: true, name: "Group Coaching"},
  GM: {auto_unlock: true, name: "Group Meditation"},
  DB: {auto_unlock: true, name: "Discussion Board"},
  AD: {auto_unlock: true, name: "Accountability Triads"},
  PC: {auto_unlock: true, name: "Peer Coaching"},
  AB: {auto_unlock: true, name: "Annual Goal Buddy"},
  RB: {auto_unlock: true, name: "Reading Buddy"},
  SE: {auto_unlock: true, name: "Settings"},
  SC: {auto_unlock: true, name: "Security"},
  MP: {auto_unlock: true, name: "My Plan"},
  BL: {auto_unlock: true, name: "Billing"},
  IN: {auto_unlock: true, name: "Integrations"},
  SF: {auto_unlock: true, name: "Share Feedback"},
  PP: {auto_unlock: true, name: "Privacy Policy"},
  LG: {auto_unlock: true, name: "Logout"},
  AS: {auto_unlock: false, name: "Assessment"},
  AE: {auto_unlock: true, name: "Target Roles/Industries"},
  RR: {auto_unlock: false, name: "Role Research"},
  RI: {auto_unlock: false, name: "Industry Research"},
  CO: {auto_unlock: false, name: "Contacts Brainstorm"},
  ED: {auto_unlock: false, name: "Outreach Drafts"},
  NT: {auto_unlock: false, name: "Networking Tracker"},
  CP: {auto_unlock: false, name: "Call Prep"},
  CN: {auto_unlock: false, name: "Call Notes"},
  NF: {auto_unlock: false, name: "Networking Reflections"},
  NA: {auto_unlock: false, name: "Networking Add New"},
  EN: {auto_unlock: false, name: "Experiences Add New"},
  PS: {auto_unlock: false, name: "Professional Summary"},
  RE: {auto_unlock: false, name: "Resume"},
  CL: {auto_unlock: false, name: "Cover Letter"},
  LK: {auto_unlock: false, name: "Linkedin Profile"},
  IR: {auto_unlock: false, name: "Interview Research"},
  BP: {auto_unlock: false, name: "Interview Responses"},
  JR: {auto_unlock: false, name: "Reflections"},
  JS: {auto_unlock: false, name: "JobSearch Add New"},
  CR: {auto_unlock: false, name: "Compare Roles"},
  PCE: {auto_unlock: false, name: "Pie Chart Exercise"},
  RV: {auto_unlock: false, name: "Resume Vision Exercise"},
  KD: {auto_unlock: false, name: "Key Definitions"},
  ID: {auto_unlock: false, name: "Identify Gaps"},
  CT: {auto_unlock: true, name: "Career Trajectory"},
  SO: {auto_unlock: false, name: "Strengths Overview"},
  SG: {auto_unlock: false, name: "Skill Gap Analysis"},
  JP: {auto_unlock: false, name: "Job Posting Exercise"},
  LO: {auto_unlock: false, name: "Upskilling Tracker"},
  OT: {auto_unlock: false, name: "Compare Options"},
  EP: {auto_unlock: false, name: "Education Planning"},
  MC: {auto_unlock: false, name: "My Credentials"},
  KL: {auto_unlock: true, name: "Key Links"},
  SD: {auto_unlock: false, name: "Soft Skill Development"},
  BS: {auto_unlock: false, name: "Boundary Setting"},
  UP: {auto_unlock: false, name: "Communication"},
  TM: {auto_unlock: false, name: "Time Management"},
  PM: {auto_unlock: false, name: "Project Management"},
  IF: {auto_unlock: false, name: "Improving Focus"},
  IV: {auto_unlock: false, name: "Influence & Visibility"},
  VP: {auto_unlock: false, name: "Video Pitch"},
  PW: {auto_unlock: false, name: "Portfolio/Website"},
  TL: {auto_unlock: false, name: "Thought Leadership"},
  AK: {auto_unlock: false, name: "ATS Keywords"},
  PI: {auto_unlock: false, name: "Mindset Preparation"},
  PN: {auto_unlock: false, name: "Places To Network"},
  EV: {auto_unlock: true, name: "Past Events"},
  UE: {auto_unlock: true, name: "Upcoming Events"},
  FE: {auto_unlock: true, name: "Find Events"},
  OD: {auto_unlock: false, name: "Onboarding 30/60/90"},
  OC: {auto_unlock: false, name: "Onboarding Checklist"},
  PR: {auto_unlock: false, name: "Promotions"},
  IM: {auto_unlock: false, name: "Internal Mobility"},
  MV: {auto_unlock: false, name: "Performance Reviews"},
  JE: {auto_unlock: false, name: "Job Expectations"},
  CG: {auto_unlock: false, name: "Annual Goals"},
  SU: {auto_unlock: false, name: "Stakeholder Updates"},
  TA: {auto_unlock: false, name: "Track Achievements"},
  EM: {auto_unlock: false, name: "Roadmap"},
  CS: {auto_unlock: false, name: "Customer Personas"},
  MR: {auto_unlock: false, name: "Market Research"},
  DO: {auto_unlock: false, name: "Define Offerings"},
  FN: {auto_unlock: false, name: "Financials"},
  MK: {auto_unlock: false, name: "Marketing"},
  SL: {auto_unlock: false, name: "Sales"},
  PD: {auto_unlock: false, name: "Product Development"},
  ET: {auto_unlock: false, name: "Team Management"},
  EL: {auto_unlock: false, name: "Legal"},
  OP: {auto_unlock: false, name: "Operations"},
  JT: {auto_unlock: false, name: "Progress Tracker"},
  SN: {auto_unlock: false, name: "Strategy and Direction"},
  CA: {auto_unlock: false, name: "Calendar"},
  JA: {auto_unlock: false, name: "Suggested Schedule"},
  MSC: {auto_unlock: true, name: "My Schedule"},
  AT: {auto_unlock: false, name: "Job Search Tracker"},
  TJ: {auto_unlock: false, name: "Target Job Postings"},
  TC: {auto_unlock: false, name: "Target Companies"},
  SA: {auto_unlock: false, name: "Staffing Agencies"},
  VR: {auto_unlock: false, name: "Visa Resources"},
  SP: {auto_unlock: false, name: "Set Priorities"},
  QT: {auto_unlock: false, name: "Questions To Ask"},
  MW: {auto_unlock: false, name: "Mock Interview"},
  CI: {auto_unlock: false, name: "Case Interview"},
  TE: {auto_unlock: false, name: "Technical Interview"},
  IW: {auto_unlock: false, name: "Interview Follow-Ups"},
  ST: {auto_unlock: false, name: "Standing Out"},
  OA: {auto_unlock: false, name: "Offer Analysis"},
  SH: {auto_unlock: false, name: "Salary Research"},
  SK: {auto_unlock: true, name: "Key Links"},
  HT: {auto_unlock: true, name: "Helpful Tools"},
  WVM: {auto_unlock: true, name: "WOKEN Videos Meditations"},
  OVD: {auto_unlock: true, name: "Other Videos"},
  WB: {auto_unlock: true, name: "WOKEN Book"},
  OTB: {auto_unlock: true, name: "Other Books"},
  WKB: {auto_unlock: true, name: "WOKEN Blogs"},
  OBL: {auto_unlock: true, name: "Other Blogs"},
  WW: {auto_unlock: true, name: "WOKE NWorkshops"},
  PDC: {auto_unlock: true, name: "Podcasts"},
  TMP: {auto_unlock: true, name: "Templates"},
  FAQ: {auto_unlock: true, name: "FAQ"},
  WHB: {auto_unlock: true, name: "Whiteboard"},
  KLJ: {auto_unlock: true, name: "Key Links"},
  MI: {auto_unlock: true, name: "Setup Call with Coach"},
  NP: {auto_unlock: true, name: "Next Phase"},
  TI: {auto_unlock: false, name: "Target Industries"},
  TR: {auto_unlock: false, name: "Targer Roles"},
  
  // ON: {auto_unlock: false, name: "Onboarding"},
  // RN: {auto_unlock: false, name: "Research Add New"},
}

export { STEP_KEY, subSteps, stepOrder, canBeNotified, stepsAutoUnlockObj };

export default steps;
